import type { ReactNode } from 'react';
import { RiInboxLine } from '@remixicon/react';
import type { IconComponent } from '@/app/navigation/types';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: IconComponent;
  action?: ReactNode;
  compact?: boolean;
}

/**
 * Boş durum.
 *
 * "Kayıt yok" demek yeterli değildir: kullanıcı NEDEN boş olduğunu ve
 * NE yapması gerektiğini bilmeli. Filtre yüzünden boşsa filtreyi temizleme,
 * gerçekten boşsa kayıt ekleme eylemi sunulur.
 */
export function EmptyState({
  title,
  description,
  icon: Icon = RiInboxLine,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <div className="empty-state" style={compact ? { padding: '1.5rem 1rem' } : undefined}>
      <span className="empty-state__icon">
        <Icon size={26} aria-hidden="true" />
      </span>
      <div className="empty-state__title">{title}</div>
      {description && (
        <p className="mb-0 fs-13" style={{ maxWidth: '30rem' }}>
          {description}
        </p>
      )}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
